import 'react-app-polyfill/ie11';
import 'react-app-polyfill/stable';

import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import { OidcProvider } from 'redux-oidc';
import { PersistGate } from 'redux-persist/integration/react'
import dayjs from 'dayjs';
import 'dayjs/locale/da';

import App from './App';
import * as serviceWorker from './serviceWorker';
import configureStore from './configureStore';
import './genericExtensions';
import userManager from './userManager';

import './styles-community-fixes.css';
import './styles-community.css';

dayjs.locale('da');

const getQueryStringParams = () => window.location.search
    ? (/^[?#]/.test(window.location.search) ? window.location.search.slice(1) : window.location.search)
        .split('&')
        .reduce((params, param) => {
            const [key, value] = param.split('=');
            params[key] = value ? decodeURIComponent(value.replace(/\+/g, ' ')) : '';
            return params;
        }, {} as { [key: string]: string })
    : {};
const tokenLinkQueryParameter = 'reauth';

const renderApp = async () => {
    const queryParams = getQueryStringParams();

    if (queryParams && queryParams[tokenLinkQueryParameter] === 'required') {
        await (await userManager).removeUser();

        window.location.href = window.location.href.replace(/(\?reauth=required$)|(&?reauth=required)/, '').replace('?&', '?');

        return;
    }

    const configuredStore = await configureStore();

    ReactDOM.render(
        <Provider store={configuredStore.store}>
            <PersistGate loading={null} persistor={configuredStore.persistor}>
                <OidcProvider store={configuredStore.store} userManager={await userManager}>
                    <App />
                </OidcProvider>
            </PersistGate>
        </Provider>,
        document.getElementById('root') as HTMLElement
    );

    serviceWorker.register({
        onUpdate: registration => {
            if (registration && registration.waiting) {
                const path = window.location.pathname;
                if (path.includes('callback.html') || path.includes('silent-renew.html')) {
                    return;
                }
                registration.waiting.postMessage({ type: 'SKIP_WAITING' });
            }
        },
    });

    let refreshing = false;
    navigator.serviceWorker.addEventListener('controllerchange', () => {
        if (refreshing) return;
        refreshing = true;
        window.location.reload();
    });
}

renderApp();